import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js';
import 'font-awesome/css/font-awesome.css'
import 'hover.css/css/hover-min.css'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import ElementUI from 'element-ui'
import locale from 'iview/dist/locale/zh-CN';
import VueCookie from 'vue-cookie'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'babel-polyfill'
import md5 from 'js-md5';//md5加密
Vue.prototype.$md5 = md5;//定义为vue原型属性
Vue.prototype.handlePreview = function (file){//预览文件全局化
    window.open(file.url || file.response.data.picPath || file.response.data.url);
}
Vue.use(ElementUI);
Vue.use(VueCookie);
Vue.use(Vant);
Vue.use(iView, { locale });
Vue.config.productionTip = false
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js